import { Injectable } from '@angular/core';
import {
  BaseClassificationService,
  Classification,
  ClassificationTypes,
} from '@vinnova/formrenderer';
import { BehaviorSubject, forkJoin, map, Observable, tap } from 'rxjs';
import { ClassificationClient } from '../clients/classification.client';

@Injectable({
  providedIn: 'root',
})
export class ClassificationService extends BaseClassificationService {
  private classifications = new BehaviorSubject<Map<string, Classification[]>>(
    new Map<string, Classification[]>(),
  );
  private classifications$ = this.classifications.asObservable();

  constructor(private classificationClient: ClassificationClient) {
    super();
  }

  public getAllClassification(typeId: string): Observable<Classification[]> {
    return this.classifications$.pipe(
      map((classifications) => classifications.get(typeId)),
    );
  }

  public fetchAllClassifications(): Observable<Classification[][]> {
    const fetchObservables = {};
    const classificationsValue = this.classifications.value;
    for (const classificationType of Object.values(ClassificationTypes)) {
      if (classificationsValue.has(classificationType)) {
        continue;
      }
      fetchObservables[classificationType] =
        this.classificationClient.getAllClassification(classificationType);
    }
    return forkJoin(fetchObservables).pipe(
      tap((values) => {
        const classificationsValue = this.classifications.value;
        for (const [key, value] of Object.entries(values)) {
          classificationsValue.set(key, value);
        }
        this.classifications.next(classificationsValue);
      }),
    );
  }
}
